const {EventRPCBridge} = require('../EventRPCBridge');


const MSG_TYPES = {
	PING: 'Cordova_RPCPing',
	PONG: 'Cordova_RPCPong',
	INVOKE: 'Cordova_RPCInvoke',
	INVOKE_COMPLETE: 'Cordova_RPCComplete',
}


let hasBridge = false;
// a cordova bridge is only possible in an iframe environment (we have a window.parent)
if(window.parent && window.self !== window.top) {
	console.log('Have window parent, waiting for parent bridge.');
	/*
	 Because we dont know if the window.parent is a native application and has a cordova bridge we need to
	 do some verification:

	 This is like a server PING -> PONG request to see if the bridge is there.

	 1. Client "connects" by listening for messages
	 2. Client sends "RPCPing" message to parent
	 3. Server listens for "RPCPing" and sends "RPCPong" message back
	 4. Client knows it's connected and can start sending messages

	 Its like sonar with a specific signature
	 */

	// listen for PONG responses
	window.addEventListener('message', function(e) {
		const type = e?.data?.type;

		// if we get a ping message from the parent or get our pong back then we know were ready
		// this is a sonar ping to see if the bridge is there
		if(type === MSG_TYPES.PING) {
			window.parent.postMessage({
				type: MSG_TYPES.PONG,
			}, '*');
			console.log('Forms cordova bridge ready');
			hasBridge = true;
		} else if(type === MSG_TYPES.PONG) {
			console.log('Forms cordova bridge ready');
			hasBridge = true;
		}
	}, false);

	// send out a PING and see if we can get a pong back, the hosting application should also send out a ping when its ready
	window.parent.postMessage({
		type: MSG_TYPES.PING,
	}, '*');
}


/**
 * CordovaNativeBridge is a class that provides a way to call native methods from a webview.
 * Communication is done through the postMessage API using the EventRPCBridge.
 */
class CordovaNativeBridge {
	/**
	 * @type {EventRPCBridge}
	 * @private
	 */
	_eventBridge;

	constructor() {
		if(!window.parent) {
			console.error('No native message message handler found but native bridge was constructed. This is likely indicative of an problem');
		}

		this._eventBridge = new EventRPCBridge({
			postMessage: this._postMessage.bind(this),
		});

		this._listenForRPCMessages();
	}

	/**
	 * Listens for messages from the native side of the bridge and forwards them to the event bridge handler
	 * @private
	 */
	_listenForRPCMessages() {
		window.addEventListener('message', (event) => {
			console.log('Message received', event);
			const detail = event.data;
			if(detail && detail.type === MSG_TYPES.INVOKE_COMPLETE) {
				this._eventBridge.onRPCMethodComplete(detail);
			}
		});
	}

	_postMessage(message) {
		if(!window.parent) {
			throw new Error('Cannot post message to parent window, no parent window found');
		}
		window.parent.postMessage({
			type: MSG_TYPES.INVOKE,
			message: message,
		}, '*');
	}



	/**
	 * Invoke the native method with the given arguments.
	 * @param {string} method
	 * @param {Object} args
	 * @return {Promise<unknown>}
	 */
	async invokeNativeMethod(method, args) {
		return this._eventBridge.invokeRPCMethod(method, args);
	}
}

CordovaNativeBridge.supported = () => {
	return Boolean(hasBridge);
}

module.exports = {
	CordovaNativeBridge
};